module.exports = __webpack_public_path__ + "img/campaign-not-sent.fc157581.svg";